import React, { useEffect, useState } from 'react'
import InvoiceList from './InvoiceList'
import './cartao-credit-invoices.css';
import { PageHeader } from '../../page-header';
import moment from 'moment';
import { AiFillFileText } from 'react-icons/ai';
import CreditLimitSection from './credit-limit-section';
import InvoiceCardSelector from './invoice-card-selector';
import InvoiceTransactionsList from './invoice-transactions-list';
import { IoChevronBack } from 'react-icons/io5';
import InvoicePaymentSection from './invoice-payment-section';
import { Skeleton } from "antd";
import { invoiceCardStatus } from '../../../utils/enums/cardEnums';
import { useCards } from '../../../hooks/useCards';

export const Invoices = () => {
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);

  const { cards, getCardData, invoices, getInvoices, getInvoiceTransactions, invoiceTransactions, loading } = useCards();

  const handleInvoiceClick = (invoice) => {
    setSelectedInvoice(invoice);
    getInvoiceTransactions(invoice.id);
  }

  useEffect(() => {
    getInvoices();
    getCardData();
  }, []);

  useEffect(() => {
    if (invoices && invoices.length > 0) {
      const currentInvoice = invoices.find(invoice => invoice.status === "OPEN");
      if (currentInvoice) {
        setCurrentInvoice(currentInvoice);
      } else {
        setCurrentInvoice(invoices[0]);
      }
    }
  }, [invoices]);

  return (
    <div className="invoice-container">
      <div className="invoice-page-header">
        <PageHeader title="Faturas" pages={[{ name: 'Cartão', link: '/pagina-cartao' }, { name: 'Faturas', link: '' }]} />
      </div>
      <div className='invoice-content'>
        {
          !selectedInvoice && (
            <div className="invoice-list-container">
              <div className="invoice-list-header">
                <h3>Minhas faturas</h3>
                <div className={`resumo-box resumo-box-border-${currentInvoice?.status?.toLocaleLowerCase() || 'default'}`}>
                  {
                    loading ? (
                      <Skeleton active paragraph={{ rows: 2 }} />
                    ) : currentInvoice ? (
                      <>
                        <div className="resumo-header">
                          <h2>Fatura atual</h2>
                          <div className={`status-tag status-${currentInvoice.status.toLocaleLowerCase()}`}>{invoiceCardStatus[currentInvoice.status]}</div>
                        </div>
                        <div className="resumo-info">
                          <div className="resumo-data">
                            <div><strong>{moment(currentInvoice.dueDate).format('MMMM YYYY').toLocaleUpperCase()}</strong></div>
                            <div className="small-text">Vencimento em {moment(currentInvoice.dueDate).format('DD/MM/YYYY')}</div>
                            <div className="small-text">Período: {moment(currentInvoice.dueDate).subtract(35, 'days').format('DD/MM/YYYY')} - {moment(currentInvoice.dueDate).subtract(5, 'days').format('DD/MM/YYYY')}</div>
                          </div>
                          <div className="resumo-valor">
                            <div>{Number(currentInvoice.totalAmount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="resumo-header">
                        <h2>Nenhuma fatura encontrada</h2>
                      </div>
                    )
                  }
                </div>
              </div>
              {!loading && (!invoices || invoices.length === 0) ? (
                <div className="empty-invoices-state" style={{ textAlign: 'center', padding: '3rem 1rem' }}>
                  <AiFillFileText size={48} color="var(--text-secondary, #888)" style={{ marginBottom: '1rem', opacity: 0.6 }} />
                  <h4 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>Nenhuma fatura disponível</h4>
                  <p style={{ color: 'var(--text-secondary, #888)', fontSize: '0.95rem', maxWidth: '400px', margin: '0 auto' }}>
                    Seu cartão de crédito ainda não possui faturas. Elas serão geradas automaticamente após a utilização do cartão.
                  </p>
                </div>
              ) : (
                <InvoiceList invoices={invoices} onInvoiceClick={handleInvoiceClick} loading={loading} />
              )}
            </div>
          )
        }
        {
          selectedInvoice && (
            <>
              <div className="invoice-header">
                <IoChevronBack className='back-icon' onClick={() => setSelectedInvoice(null)} />
                <h3>Detalhes da fatura</h3>
              </div>
              <div className='general-info col-md-5'>
                <span className='info-title'>Valor Total da Fatura</span>
                <span className='info-value'>{Number(selectedInvoice.totalAmount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                {
                  selectedInvoice.status !== "PAID" ?
                    <span className='info-title'>Vencimento em {moment(selectedInvoice.dueDate).format('DD/MM/YYYY')}</span>
                    :
                    <span className='info-title'>Pagamento efetuado em {moment(selectedInvoice.paidAt).format('DD/MM/YYYY')}</span>
                }
              </div>

              <InvoiceCardSelector cardList={cards} selectedCardIndex={selectedCardIndex} setSelectedCardIndex={setSelectedCardIndex} />
              <CreditLimitSection card={selectedCardIndex ? cards.find(card => card.id === selectedCardIndex) : cards[0]} />

              {(selectedInvoice.status === "CLOSED" || selectedInvoice.status === "OVERDUE") && (
                <InvoicePaymentSection invoice={selectedInvoice} />
              )}

              <InvoiceTransactionsList invoiceTransactions={invoiceTransactions} />
            </>
          )
        }
      </div>
    </div>
  )
}